// src/pages/Home.js
import React, { useEffect } from "react";
import { useUser } from "../hooks/useUser";
import "../styles/global.css";
import "../styles/home.css";
import { showAlertAndSendMessage } from "../utils/showAlertAndSendMessage";
import { loadImage } from "../utils/loadImage";

function Home() {
  const { user, loading } = useUser();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/sweetalert2@11";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <style jsx>
        {`
          .btn-menu p {
            font-size: 20px;
            font-weight: bold;
            color: white;
          }
          .btp:hover,
          .btp:focus {
            background: rgba(255, 255, 255, 0.5);
            color: black !important;
          }
          .btp:hover p,
          .btp:focus p {
            color: black !important;
          }
          .btp {
            cursor: pointer;
            border-radius: 10px;
          }
        `}
      </style>
      <div className="navbar">
        <img
          src="icons/icon_person.png"
          alt="Profile"
          className="profile-icon"
        />
        <a href="/logout" className="logout navbar-item">
          Logout
        </a>
      </div>
      <div className="container">
        <h1>NÄTUR</h1>
        <h2>Welcome, {user?.full_name}</h2>
        <div className="row">
          <div
            className="col-md-3 col-sm-6 col-xs-12 col-6 btp"
            onClick={() => {
              window.location.href = "/chat";
            }}
          >
            <button type="button" className="btn-menu">
              <img
                src="icons/icon_chat.png"
                alt="Chat"
                height={120}
                style={{ marginTop: "-7px" }}
              />
              <p>NÄTUR Chat</p>
            </button>
          </div>
          <div
            className="col-md-3 col-sm-6 col-xs-12 col-6 btp"
            onClick={() => {
              window.location.href = "/trees";
            }}
          >
            <button type="button" className="btn-menu">
              <img src="icons/icon_flight.png" alt="Chat" height={120} />
              <p>Flight Radar</p>
            </button>
          </div>
          <div
            className="col-md-3 col-sm-6 col-xs-12 col-6 btp"
            // onClick={loadImage}
            onClick={() => {
              window.location.href = "/album";
            }}
          >
            <button type="button" className="btn-menu">
              <img src="icons/icon_album.png" alt="Chat" height={120} />
              <p>Album</p>
            </button>
          </div>
          <div
            className="col-md-3 col-sm-6 col-xs-12 col-6 btp"
            onClick={showAlertAndSendMessage}
          >
            <button type="button" className="btn-menu">
              <img src="icons/icon_SOS.png" alt="Chat" height={120} />
              <p>SOS</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
